import { render, staticRenderFns } from "./LahanUmum.vue?vue&type=template&id=e1720688"
import script from "./LahanUmum.vue?vue&type=script&lang=js"
export * from "./LahanUmum.vue?vue&type=script&lang=js"
import style0 from "./LahanUmum.vue?vue&type=style&index=0&id=e1720688&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports